// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"259":"timeout","535":"login","922":"edit"}[chunkId] || chunkId) + "-legacy." + {"259":"c7508f4e","535":"837b7665","572":"06ff935a","922":"b12661f9"}[chunkId] + ".js";
};